import type { CaseReducer, PayloadAction } from '@reduxjs/toolkit'
import { isCacheValid } from '../../../entry.cache'
import type { FamilyCacheState } from '../types'
import type { ResponseMessage } from '@kiddocare-platform/portal-common/base'
import type { VisitType } from '@kiddocare-platform/portal-common/family'

const addVisitTypes: CaseReducer<
  FamilyCacheState,
  PayloadAction<ResponseMessage<Array<VisitType>>>
> = (state, action) => {
  state.visitTypes = { value: action.payload, cachedAt: Date.now() }
}

const removeVisitTypes: CaseReducer<FamilyCacheState, PayloadAction<void>> = (state) => {
  state.visitTypes = undefined
}

const purgeExpiredVisitTypesCache: CaseReducer<FamilyCacheState> = (state) => {
  if (!isCacheValid(state.visitTypes)) {
    state.visitTypes = undefined
  }
}

export const visitTypesReducers = {
  addVisitTypes,
  removeVisitTypes,
  purgeExpiredVisitTypesCache,
}
